/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplyStarterKitDto,
  StarterKitApplyResultResponse,
  StarterKitListResponse,
  StarterKitPreviewResponse
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * کارت‌های انتخاب بسته در گام «خدمات» ویزارد. محتوای ثابت است و به داده‌های کلینیک وابسته نیست؛ برای دیدن اثر واقعی روی همین کلینیک از preview استفاده کنید.
 * @summary فهرست بسته‌های راه‌اندازی
 */
export const starterKitsList = (

 signal?: AbortSignal
) => {


      return apiClient<StarterKitListResponse>(
      {url: `/api/v1/onboarding/starter-kits`, method: 'GET', signal
    },
      );
    }




export const getStarterKitsListQueryKey = () => {
    return [
    `/api/v1/onboarding/starter-kits`
    ] as const;
    }


export const getStarterKitsListQueryOptions = <TData = Awaited<ReturnType<typeof starterKitsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStarterKitsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof starterKitsList>>> = ({ signal }) => starterKitsList(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof starterKitsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StarterKitsListQueryResult = NonNullable<Awaited<ReturnType<typeof starterKitsList>>>
export type StarterKitsListQueryError = unknown


export function useStarterKitsList<TData = Awaited<ReturnType<typeof starterKitsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof starterKitsList>>,
          TError,
          Awaited<ReturnType<typeof starterKitsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStarterKitsList<TData = Awaited<ReturnType<typeof starterKitsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof starterKitsList>>,
          TError,
          Awaited<ReturnType<typeof starterKitsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStarterKitsList<TData = Awaited<ReturnType<typeof starterKitsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست بسته‌های راه‌اندازی
 */

export function useStarterKitsList<TData = Awaited<ReturnType<typeof starterKitsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStarterKitsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * هیچ چیزی نوشته نمی‌شود. همان بررسی‌های اجرای واقعی را انجام می‌دهد و می‌گوید چند مورد ساخته و چند مورد به‌دلیل وجود قبلی رد می‌شود.
 * @summary پیش‌نمایش اجرای بسته روی کلینیک جاری
 */
export const starterKitsPreview = (
    key: string,
 signal?: AbortSignal
) => {


      return apiClient<StarterKitPreviewResponse>(
      {url: `/api/v1/onboarding/starter-kits/${key}/preview`, method: 'GET', signal
    },
      );
    }




export const getStarterKitsPreviewQueryKey = (key: string,) => {
    return [
    `/api/v1/onboarding/starter-kits/${key}/preview`
    ] as const;
    }


export const getStarterKitsPreviewQueryOptions = <TData = Awaited<ReturnType<typeof starterKitsPreview>>, TError = void>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsPreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStarterKitsPreviewQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof starterKitsPreview>>> = ({ signal }) => starterKitsPreview(key, signal);





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof starterKitsPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StarterKitsPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof starterKitsPreview>>>
export type StarterKitsPreviewQueryError = void


export function useStarterKitsPreview<TData = Awaited<ReturnType<typeof starterKitsPreview>>, TError = void>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof starterKitsPreview>>,
          TError,
          Awaited<ReturnType<typeof starterKitsPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStarterKitsPreview<TData = Awaited<ReturnType<typeof starterKitsPreview>>, TError = void>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof starterKitsPreview>>,
          TError,
          Awaited<ReturnType<typeof starterKitsPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStarterKitsPreview<TData = Awaited<ReturnType<typeof starterKitsPreview>>, TError = void>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیش‌نمایش اجرای بسته روی کلینیک جاری
 */

export function useStarterKitsPreview<TData = Awaited<ReturnType<typeof starterKitsPreview>>, TError = void>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof starterKitsPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStarterKitsPreviewQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * خدمات، تعرفه، رضایت‌نامه، پیامک‌ها، قواعد یادآوری، اتاق‌ها، نقش‌ها، کالاهای مصرفی و برنامهٔ هفتگی را در **یک تراکنش** می‌سازد. هر موردی که از قبل وجود داشته باشد دست‌نخورده باقی می‌ماند؛ اجرای دوباره هیچ تغییری ایجاد نمی‌کند. هیچ بچ انبار ساخته نمی‌شود.
 * @summary اجرای بستهٔ راه‌اندازی
 */
export const starterKitsApply = (
    applyStarterKitDto: ApplyStarterKitDto,
 signal?: AbortSignal
) => {


      return apiClient<StarterKitApplyResultResponse>(
      {url: `/api/v1/onboarding/starter-kits/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyStarterKitDto, signal
    },
      );
    }




export const getStarterKitsApplyMutationKey = () => ['starterKitsApply'] as const;

export const getStarterKitsApplyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof starterKitsApply>>, TError,StarterKitsApplyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof starterKitsApply>>, TError,StarterKitsApplyMutationVariables, TContext> => {

const mutationKey = getStarterKitsApplyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof starterKitsApply>>, StarterKitsApplyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  starterKitsApply(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StarterKitsApplyMutationResult = NonNullable<Awaited<ReturnType<typeof starterKitsApply>>>
    export type StarterKitsApplyMutationBody = ApplyStarterKitDto
    export type StarterKitsApplyMutationError = void
    export type StarterKitsApplyMutationVariables = {data: ApplyStarterKitDto}

    /**
 * @summary اجرای بستهٔ راه‌اندازی
 */
export const useStarterKitsApply = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof starterKitsApply>>, TError,StarterKitsApplyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof starterKitsApply>>,
        TError,
        StarterKitsApplyMutationVariables,
        TContext
      > => {
      return useMutation(getStarterKitsApplyMutationOptions(options), queryClient);
    }
